import(/* webpackMode: "eager", webpackExports: ["BusinessCaseCalculator"] */ "/Users/timantos/Projects/SagenceWebsite/src/components/sections/BusinessCaseCalculator.tsx");
